import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    step: 1,
    tesseramento: {
      player: {
        nickname: "",
        sezione: "",
        tempo: "",
        ruolo: "",
        comp: false
      },
      personali: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        sex: "m",
        birth: {
          country: "",
          state: "",
          city: "",
          date: ""
        },
        residence: {
          country: "",
          state: "",
          city: "",
          address: "",
          zipcode: ""
        },
        taxid: ""
      },
      payment: {
        tier: 1,
        orderId: "",
        paymentStatus: "",
        terms: ""
      }
    }
  },
  mutations: {
    MutateStep(state, newstep) {
      state.step = newstep;
    },
    UpdatePaymentOrder(state, order) {
      state.tesseramento.payment.orderId = order;
    },
    UpdatePaymentStatus(state, status) {
      state.tesseramento.payment.paymentStatus = status;
    }
  },
  actions: {
    EmitStep(context, value) {
      context.commit("MutateStep", value);
    },
    UpdateOrder(context, value) {
      context.commit("UpdateOrder", value);
    }
  },
  modules: {}
});
